import React from 'react';
import { inject, observer } from 'mobx-react';
import MainHeader from 'components/MainHeader';
import Footer from 'components/Footer';
import LoadingBar from 'components/LoadingBar';
import Modal from 'components/Modal';
import styles from './styles.module.scss';

const AppLayout = ({ hasBackground = true, children, store }) => (
    <div className={styles.AppLayout}>
        <LoadingBar
            started={!!(store.loading.startsCount)}
            value={store.loading.value}
        />
        <MainHeader
            hasBackground={hasBackground}
            userName={store.profile.userNameNavbar}
            claimsNotifCount={store.profile.user.unreadMessagesByClientCount}
        />
        {store.app.modalData && (
            <Modal
                title={store.app.modalData.title}
                body={<p>{store.app.modalData.body}</p>}
                footer={store.app.modalData.footer}
                handleClose={() => store.app.setModalData(null)}
            />
        )}
        {children}
        <Footer/>
    </div>
);

export default inject('store')(observer(AppLayout));
